var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.medal.title),expression:"medal.title"}],attrs:{"src":_vm.medal.src}})}
var staticRenderFns = []

export { render, staticRenderFns }